// @flow
import * as React from 'react';

import AdminUploadedFilesContainer from './AdminUploadedFilesContainer';
import AdminUploadedFilesView from './AdminUploadedFilesView';

type Props = {
  viewingOrgUuid: string,
};

export default class AdminUploadedFiles extends React.Component<Props, *> {
  render() {
    const { viewingOrgUuid } = this.props;

    return (
      <AdminUploadedFilesContainer viewingOrgUuid={viewingOrgUuid}>
        {props => <AdminUploadedFilesView {...props} />}
      </AdminUploadedFilesContainer>
    );
  }
}
